export const defaultTimezone = 'Europe/Warsaw'
